import {css} from 'lit';
export const styles = css`:host {
  --background: var(--primary-800);
  --background-hover: var(--primary-500);
  --background-active: var(--primary-700);
  --icon-color: var(--contrast-light);
}

ef-dropdown {
  --dropdown-content-background: var(--contrast-light);
}

.icon-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60px;
  min-width: 44px;
  padding: 4px;
  background-color: var(--background);
  border: none;
}

@media screen and (min-width: 768px) {

.icon-btn {
    padding: 15px;
    height: 100%
}
  }

[aria-expanded='true'] {
  background-color: var(--background-hover);
}

@media (hover: hover) {
  .icon-btn:hover {
    background-color: var(--background-hover);
  }
}

.icon-btn:active {
  background-color: var(--background-active);
}

ef-icon {
  color: var(--icon-color);
}

.dropdown {
  width: 400px;
  background-clip: padding-box;
  border: 1px solid var(--border-dark);
}

header,
footer {
  display: flex;
  justify-content: center;
  padding: 8px;
  text-align: center;
}

header {
  border-bottom: 1px solid var(--border);
}

header p {
  margin-top: 0;
  font-size: var(--font-size-base);
  color: var(--gray-700);
  line-height: 1;
}

main {
  max-height: 75vh;
  overflow-x: hidden;
}

bu-notification {
  --border-radius: 0;
}

bu-notification + bu-notification {
    margin-top: 4px;
  }

/* TODO: Extract to common button styles */

.btn {
  padding: 4px 8px;
  width: auto;
  background-color: var(--gray-200);
  border: 1px solid var(--gray-400);
  border-radius: 4px;
  white-space: nowrap;
  cursor: pointer;
  touch-action: manipulation;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
}

.btn ef-icon-block {
    font-size: var(--font-size-sm);
    color: var(--text-primary);
    line-height: 1.4px;
  }

@media (hover: hover) {
  .btn:hover {
    background-color: var(--gray-400);
  }
}

.btn:active {
  background-color: var(--gray-500);
}
`;
export default styles;
